class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.getElementById('shopify-section-moynat-header');
    this.headerWrapper = document.querySelector('sticky-header.header-wrapper');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.stickyThreshold = 100;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');
    this.isRevealed = true;
    this.isInThreshold = true;
    this.announcementHeight =
      document.querySelector('#announcement-bar')?.offsetHeight;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 33);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }

    if (this.currentScrollTop < this.stickyThreshold) {
      document.body.classList.remove('sticky-header');

      if (this.headerWrapper && !this.isInThreshold) {
        this.headerWrapper.style.paddingTop = `${parseInt(this.announcementHeight) || 0}px`;
        this.isInThreshold = true;
      }
    } else {
      if (this.isInThreshold) {
        this.headerWrapper.style.paddingTop = '0px';
      }
      this.isInThreshold = false;
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (!this.isRevealed) return;
    this.isRevealed = false;
    // use `hide-nav` class to show/hide the header

    this.headerWrapper?.classList.add('hide-nav');

    this.closeSearchModal();
    setTimeout(() => {}, 300);
  }

  reveal() {
    if (this.isRevealed) return;
    this.isRevealed = true;
    // use `hide-nav` class to show/hide the header

    this.headerWrapper?.classList.remove('hide-nav');

    document.body.classList.add('sticky-header');
    document.body.classList.remove('header-on-load');

    this.header.classList.add('shopify-section-header-sticky', 'animate');
    setTimeout(() => {}, 300);
  }

  reset() {
    this.header.classList.remove('shopify-section-header-sticky', 'animate');
    document.body.classList.remove('header-on-load');
  }

  closeMenuDisclosure() {
    this.disclosures =
      this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector('details-modal');
  }
}

customElements.define('sticky-header', StickyHeader);
